import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

const RFixasRow = (props) => {
    let colorCode;
    if (props.tipo === 'DEP') colorCode = '#F4F9F5';
    if (props.tipo === 'RET') colorCode = '#FDF7F7';
    if (props.tipo === 'REND') colorCode = '#EFF8FB';

    return (
        <li className="list-group-item list-group-item-action flex-column align-items-start" style={{ "backgroundColor": colorCode }}>
            <div className="row">
                <div className="col-10">
                    <div className="d-flex w-100 justify-content-between">
                        <small>{moment(props.data).format('DD/MM/YYYY')}</small>
                        <small>{parseFloat(props.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                        <small>{props.tipo}</small>
                    </div>
                </div>
                <div className="col">
                    <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                        onClick={() => props.handleDelete(props.id)} />
                </div>
            </div>
        </li>
    );
};

RFixasRow.propTypes = {
    tipo: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
    valor: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    handleDelete: PropTypes.func.isRequired,
};

export default RFixasRow;


// WEBPACK FOOTER //
// ./src/components/rfixas/RFixasRow.js